import { authorize as login } from "@/api/index"

/**
 * 微信登录
 * @param {import("vue-router").RouteLocationNormalizedLoaded} route 
 * @param {Function} fn 
 * @returns 
 */
export default function (route, fn) {

	if (!hasTokenExpire()) return fn && fn()
	if (route.query.code) {
		login(route.query.code).then(({ data }) => {
			if (data.code == 0) {
				localStorage.setItem('token', data.data.accessToken);
				localStorage.setItem("expire", new Date().getTime()+ (7000 * 1000) )
				let queryString = localStorage.getItem('queryString');
				let url = window.location.protocol + "//" + window.location.host + route.path + queryString;
				return window.location.href = url;
			}
			else {
				return JumpWx(route);
			}
		})
	}
	else {
		// 该步骤保存用户要的参数
		let queryString = window.location.search
		localStorage.setItem('queryString', queryString);
		// 跳转
		return JumpWx(route);
	}
}

/**
 * 
 * @param {import("vue-router").RouteLocationNormalizedLoaded} route 
 * @returns 
 */
function JumpWx(route) {
	var appId = "wx32b0c982a6b6f43d";
	var redirectUri = location.protocol + "//" + location.host + route.path
	var scope = "snsapi_userinfo";
	var state = 'test';
	var authorizeUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + encodeURIComponent(appId) + "&redirect_uri=" + encodeURIComponent(redirectUri) + "&response_type=code&scope=" + encodeURIComponent(scope) + "&state=" + encodeURIComponent(state) + "#wechat_redirect";
	return window.location = authorizeUrl;
}
/**
 * token是否过期
 * @returns {Boolean} 过期返回true 未过期返回false
 */
export function hasTokenExpire() {
	const token = localStorage.getItem('token')
	const expire = localStorage.getItem("expire")
	const now = new Date().getTime()
	if (token && expire ) {
		return false;
	}
	return true;
}